import type { UserInfo } from '@mairistem/comptabilite';
import type { TemplateRequestGet } from '@mairistem/finances-utils';
import { request } from '@mairistem/tools';

const getUserInfo = (params: URLSearchParams) => {
	const url = '/api/finances/comptabilite/parametrescomptabilites/userInfo?';
	return request.get<unknown, TemplateRequestGet<UserInfo>>(
		`${url}${params.toString()}`,
	);
};

export default getUserInfo;
